var render = function render(){var _vm=this,_c=_vm._self._c;return _c('curve-page',{attrs:{"project-id":_vm.THSR_MANUAL_PROJECT_ID}})
}
var staticRenderFns = []

export { render, staticRenderFns }